import { render, staticRenderFns } from "./ReleaseNotesDrawer.vue?vue&type=template&id=0cc61479&scoped=true"
import script from "./ReleaseNotesDrawer.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesDrawer.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesDrawer.vue?vue&type=style&index=0&id=0cc61479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc61479",
  null
  
)

export default component.exports